<ion-toolbar color="--ion-color-light-teal-2" class="ion-text-center">
    <ion-buttons slot="end">
        <ion-button id="RequestWireTransferDismissBtn" (click)="dismiss()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar>
<ion-grid>
    <ion-row>
        <ion-col size="12">
            <ion-row>
                <ion-col class="text-center" size="12">
                    <ion-text class="alert-icon">
                        <ion-icon color="primary" size="large" name="alert"></ion-icon>
                    </ion-text>
                </ion-col>
                <ion-col size="12">
                    <ion-text class="text-center bold-text">
                        <h4>Programs are reserved when the wire transfer is received.</h4>
                    </ion-text>
                </ion-col>

                <ion-col size="12">
                    <ion-text class="text-center bold-text">
                        <h4>To reserve immediately pay using Stripe Checkout.</h4>
                    </ion-text>
                </ion-col>
            </ion-row>
        </ion-col>
    </ion-row>
</ion-grid>

<ion-footer>
    <ion-row>
        <ion-col class="text-center">
            <ion-button id="RequestWireTransferCancelBtn" mode="md" size="large" fill="outline" color="primary" type="button" (click)="dismiss()"
                >Cancel
            </ion-button>
            <ion-button id="RequestWireTransferSubmitBtn" mode="md" size="large" fill="solid" color="primary" type="button" (click)="pay($event)"
                >Continue
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>
